import { EventSource } from "../event-source";
import { Route, RoutePattern } from './route';
import { ViewConstructor } from "../view";
import { BaseApp } from '../app';

export default class Router extends EventSource
{
    private routes: Route[];
    private app: BaseApp;
    private enabled: boolean;

    private cleanedLocation: string;
    private _path: string;  
    public get path(): string { return this._path; }
    public set path(value: string)
    {
        if (value !== this._path)
        {
            this._path = value;
        }
    }

    /**
     * Creates a new instance of Router.
     * @param app App
     */
    constructor(app: BaseApp)
    {
        super();
        this.app = app;
        this.routes = [];
        this.enabled = false;

        window.addEventListener('hashchange', this.onWindowHashChange, false);
        this.onWindowHashChange(null);
    }

    /** Reacts to window hashchange events and switches to the view when the hash changes. */
    private onWindowHashChange = (e: Event) => 
    {
        let parts = window.location.hash.split('#');
        this.path = parts.length > 1 ? parts[1] : '';

        if (this.enabled)
        {
            this.run();
        }
    }

    /**
     * Adds a route configuration to the router.
     * @param pattern Pattern used to trigger the view.
     * @param viewType View constructor.
     * @param initial Initial data used as the view context data.
     */
    public add(pattern: RoutePattern, viewType: ViewConstructor, initial?: any): Router
    /**
     * Adds a route configuration to the router.
     * @param pattern Regular expression used to trigger the view.
     * @param viewTypes View constructor types (chain of views).
     * @param initial Initial data used as the view context data.
     */
    public add(pattern: RoutePattern, viewTypes: ViewConstructor[], initial?: any): Router
    public add(pattern: RoutePattern, viewTypes: ViewConstructor | ViewConstructor[], initial?: any): Router
    {
        if (!(pattern instanceof RegExp))
        {
            pattern = new RegExp(`^${pattern}$`);
        }
            
        let route = new Route(this.app, pattern, viewTypes, initial);

        this.routes.push(route);

        return this;
    }

    /** Runs the router, executes the first matching view. */
    public run(): PromiseLike<void>
    {
        this.trigger('run');
        this.enabled = true;
        let result: PromiseLike<void> = Promise.resolve();

        for (let route of this.routes)
        {
            if (route.match(this.path))
            {
                try
                {
                    result = route.run();
                }
                catch (exception)
                {
                    if (this.app.settings.debug)
                    {
                        this.app.error(exception);
                    }
                    else
                    {
                        this.app.error(exception);
                    }
                }
                finally
                {
                    return result;
                }
            }
        }

        this.app.warning(new Error(`Cound not find "${this.path}".`));
    }
}